<template>
	<el-row>
		<el-button @click="add()">添加</el-button>
		<el-table :data="tableData" border style="margin-top: 30px;">
			<el-table-column label="id" prop="id"></el-table-column>
			<el-table-column label="开始金额" prop="amountSegmentStart"></el-table-column>
			<el-table-column label="结束金额" prop="amountSegmentEnd"></el-table-column>
			<el-table-column label="推荐课程" prop="courseIdlist">
				<template slot-scope="scope">
					<el-select v-model="scope.row.courseIdlist2" multiple style="width: 100%;" :disabled="true">
						<el-option v-for="(item,index) in kcoptions" :key="item.value" :label="item.label"
							:value="item.value" :disabled="true"></el-option>
					</el-select>
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button type="text" @click="bianji(scope.row)">编辑</el-button>
					<el-button type="text" @click="shanchu(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div style="margin: 20px auto;width: 500px">
			<el-pagination background layout="total, prev, pager, next,jumper" :page-size="pageSize" :total="total"
				:page-sizes="[5,10]" :current-page.sync="pageNum" @size-change="handleSizeChange"
				@current-change="handleCurrentChange" />
		</div>
		<el-dialog :title="title" :visible.sync="dialog" center width="30%">
			<el-form :model="info" ref="info" label-position="right" label-width="100px">
				<el-form-item label="金额:">
					<el-input type="number" v-model="info.amountSegmentStart" placeholder="开始金额" style="width: 150px;">
					</el-input>
					<span>~</span>
					<el-input type="number" v-model="info.amountSegmentEnd" placeholder="结束金额" style="width: 150px;">
					</el-input>
				</el-form-item>
				<el-form-item label="推荐课程:">
					<el-select v-model="info.courseIdlist" multiple style="width: 100%;">
						<el-option v-for="(item,index) in kcoptions" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button @click="dialog = false">取消</el-button>
					<el-button type="primary" @click="sumbit()">确认</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				pageNum: 1,
				pageSize: 10,
				total: 0,
				tableData: [],
				id: 0,
				title: '',
				kcoptions: [],
				info: {
					amountSegmentStart: null,
					amountSegmentEnd: null,
					courseIdlist: [],
				},
				dialog: false
			}
		},
		methods: {
			sumbit() {
				if (this.info.amountSegmentStart == null || this.info.amountSegmentEnd == null || this.info.courseIdlist
					.length == 0) {
					this.$message.error('请先填写完整')
					return false
				}
				if (this.info.amountSegmentStart - 0 >= this.info.amountSegmentEnd - 0) {
					this.$message.error('开始金额不能大于等于结束金额')
					return false
				}
				if (this.id == 0) {
					this.$http.post('/api/statistics/ClrStatisticsController/addRecommendCourseConfigure', {
						"amountSegmentStart": this.info.amountSegmentStart,
						"amountSegmentEnd": this.info.amountSegmentEnd,
						"courseIdlist": this.info.courseIdlist.join(',')
					}).then(res => {
						console.log(res);
						if (res.data.status == 0) {
							this.$message.success('配置成功')
							this.dialog = false
							this.getList()
						} else {
							this.$message.error('配置失败')
						}
					})
				} else {
					this.$http.post('/api/statistics/ClrStatisticsController/editRecommendCourseConfigure', {
						"id": this.id,
						"amountSegmentStart": this.info.amountSegmentStart,
						"amountSegmentEnd": this.info.amountSegmentEnd,
						"courseIdlist": this.info.courseIdlist.join(','),
						"deleteStatus": 0
					}).then(res => {
						console.log(res);
						if (res.data.status == 0) {
							this.dialog = false
							this.$message.success('编辑成功')
							this.getList()
						} else {
							this.$message.error('编辑失败')
						}
					})
				}
			},
			add() {
				this.title = '配置推荐课程'
				this.dialog = true
				this.info.amountSegmentStart = null
				this.info.amountSegmentEnd = null
				this.info.courseIdlist = []
			},
			bianji(row) {
				console.log(row);
				let courseIdlist = row.courseIdlist.split(',').map(item => item - 0)
				console.log(courseIdlist);
				this.title = '编辑推荐课程'
				this.id = row.id
				this.dialog = true
				this.info.amountSegmentStart = row.amountSegmentStart
				this.info.amountSegmentEnd = row.amountSegmentEnd
				this.info.courseIdlist = courseIdlist
			},
			shanchu(row) {
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post('/api/statistics/ClrStatisticsController/editRecommendCourseConfigure', {
						"id": row.id,
						"deleteStatus": 1
					}).then(res => {
						console.log(res);
						if (res.data.status == 0) {
							this.dialog = false
							this.$message.success('删除成功')
							this.getList()
						} else {
							this.$message.error('删除失败')
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});

			},
			getList() {
				this.$http.post('/api/statistics/ClrStatisticsController/selectRecommendCourseConfigureList', {
					"pageNum": this.pageNum,
					"pageSize": this.pageSize
				}).then(res => {
					console.log(res.data.data);
					if (res.data.data.list.length > 0) {
						res.data.data.list.forEach(item => {
							item.courseIdlist2 = item.courseIdlist.split(',')
							item.courseIdlist2 = item.courseIdlist2.map(i => i - 0)
						})
					}
					this.tableData = res.data.data.list
					this.total = res.data.data.total
				})
			},
			//课程
			getKeCheng() {
				this.$http.post('/api/course/clrCourse/selectCourseList', {




				}).then(res => {
					console.log(res.data.data);
					if (res.data.data.length > 0) {
						res.data.data.forEach(i => {
							this.kcoptions.push({
								label: i.courseName,
								value: i.courseId
							})
						})
					}
				}).catch((error) => {
					this.$message.error("发生了一些错误:" + error);
				})
			},
			//页面的条数发生改变时
			handleSizeChange(size) {
				this.pageSize = size
				this.getList()
			},
			//当前页发生改变时
			handleCurrentChange(currentPage) {
				this.pageNum = currentPage
				this.getList()
			}
		},
		created() {
			this.getList()
			this.getKeCheng()
		}
	}
</script>

<style scoped>

</style>
